import { Injectable } from '@angular/core';
import { FormControl, ValidationErrors, Validators, FormGroup, ValidatorFn, AbstractControl } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class Validations {
  public static message = {

    isAlpha: [
      { type: 'pattern', message: ' Must contain only letters' }
    ],
    isNumeric: [
      { type: 'pattern', message: ' Must contain only numbers' }
    ],
    isAlphaNumeric: [
      { type: 'pattern', message: ' Must contain only letters and numbers' }
    ],
    isValidEmail: [
      { type: 'email', message: ' is not valid' }
    ],
    isValidMobile: [
      { type: 'pattern', message: ' is not valid' }
    ],
    isAlphaRequired: [
      { type: 'required', message: ' Please enter' },
      { type: 'pattern', message: ' Must contain only letters' }
    ],
    isNumericRequired: [
      { type: 'required', message: ' Please enter' },
      { type: 'pattern', message: ' Must contain only numbers' }
    ],
    isAlphaNumericRequired: [
      { type: 'required', message: ' Please enter ' },
      { type: 'pattern', message: ' Must contain only letters and numbers' }
    ],
    isWebLinkRequired: [
      { type: 'required', message: ' Please enter ' },
      { type: 'pattern', message: ' Please enter valid ' },

    ],
    isDateRequired: [
      { type: 'required', message: ' is required' }
    ],
    isRequired: [
      { type: 'required', message: ' Please enter' }
    ],
    isDateTimeRequired: [
      { type: 'required', message: ' is required' }
    ],
    isValidEmailRequired: [
      { type: 'required', message: ' Please enter' },
      { type: 'email', message: ' is not valid' },
      { type: 'Pattern', message: ' Max 64 characters before the "@" and Max 255 characters after the "@" and . is a mandatory character for a total length of 320 characters'}
    ],
    isValidIP: [
      { type: 'Pattern', message: 'Please enter valid IP address' }
    ],
    isValidMobileRequired: [
      { type: 'required', message: ' Please enter' },
      { type: 'pattern', message: ' is not valid' }
    ],
    trimedSpaces: [
      { type: 'required', message: ' Only space is not allowed' },
    ],
    isAlphaNumericWithSpaceHyphenSlash: [
      {
        type: 'pattern', message: ' Only Alphanumeric with space, hyphen and slash allowed'
      },
      { type: 'required', message: ' Please enter' },
    ],
    isAlphaNumericWithHyphen: [
      {
        type: 'pattern', message: ' Only Alphanumeric hyphen allowed'
      },
      { type: 'required', message: ' Please enter' },
    ],
    
    isAlphaNumericWithHyphenUnderscore: [
      {
        type: 'pattern', message: ' only alphanumeric hyphen and underscore allowed'
      },
      { type: 'required', message: ' Please enter' },
    ],
    isValidPasswordRequired: [
      {
        type: 'required', message: 'Please enter password'
      },
      {
        // type: 'pattern', message: 'Min Password Length should be 8 characters.\nThere should be at least 1 special character in password\nThere should be at least 1 digit in password\nThere should be at least 1 Upper Case letter in Password'
        type: 'pattern', message: 'Password instruction Not Match'
      }
    ],

    isValidConfirmPasswordRequired: [
      {
        type: 'required', message: 'Please enter confirm password'
      },
      {
        // type: 'pattern', message: 'Min Password Length should be 8 characters.\nThere should be at least 1 special character in password\nThere should be at least 1 digit in password\nThere should be at least 1 Upper Case letter in Password'
        type: 'pattern', message: 'Password instruction Not Match'
      }
    ],


    isValidIPAdddress: [{
      type: 'pattern', message: 'Please enter valid IP address'
    }
    ]
  };

  public static trimedSpaces(control: FormControl): ValidationErrors | null {

    if (control.value != null && control.value != "") {
      const isWhitespace = (control.value || '').trim().length === 0;
      const isValid = !isWhitespace;
      return isValid ? null : { 'whitespace': true };
    }
    else
      return null;
  }

  public static isAlpha() {
    return Validators.compose([
      Validators.pattern('[a-zA-Z ]*')
    ]);
  }

  public static isNumeric() {
    return Validators.compose([
      Validators.pattern('[0-9]*')
    ]);
  }

  public static isAlphaNumeric() {
    return Validators.compose([
      Validators.pattern('[a-zA-Z0-9 ]*')
    ]);
  }

  public static isValidIPAdddress() {
    return Validators.compose([
      Validators.required,
      Validators.pattern("^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$")
    ]);

  }
  public static isValidIP() {
    return Validators.compose([
      Validators.pattern("^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$")
    ]);

  }
  public static isAlphaNumericWithSpaceHyphenSlash() {
    return Validators.compose([
      Validators.required,
      Validators.pattern('[a-zA-Z0-9-/ ]*')
    ]);
  }
  public static isAlphaNumericWithHyphen() {
    return Validators.compose([
      Validators.required,
      Validators.pattern('[a-zA-Z0-9-]*')
    ]);
  }

  public static isAlphaNumericWithHyphenUnderscore() {
    return Validators.compose([
      Validators.required,
      Validators.pattern('[a-zA-Z0-9-_]*')
    ]);
  }

  public static isWebLinkRequired() {
    return Validators.compose([
      Validators.required,
      Validators.pattern('^.*[.]+.*$')

    ]);
  }

  public static isDateRequired() {
    return Validators.compose([
      Validators.required
      //Validators.pattern('[a-zA-Z ]*')
    ]);
  }

  public static isRequired() {
    return Validators.compose([
      Validators.required
    ]);
  }

  public static isDateTimeRequired() {
    return Validators.compose([
      Validators.required
    ]);
  }

  public static isValidEmail() {
    return Validators.compose([
      Validators.email
    ]);
  }

  public static isValidMobile() {
    // return Validators.compose([
    //   Validators.pattern('[6-9]\\d{9}')
    // ]);
    return Validators.compose([

      Validators.pattern('^((\\91-?)|0|091)?[0-9]{10}$')
    ]);
  }

  public static isAlphaRequired() {
    return Validators.compose([
      Validators.required,
      Validators.pattern('[a-zA-Z ]*')
    ]);
  }

  public static isNumericRequired() {
    return Validators.compose([
      Validators.required,
      Validators.pattern('[0-9]*')
    ]);
  }

  public static isNumericRequiredNotRequered() {
    return Validators.compose([
      Validators.pattern('[0-9]*')
    ]);
  }

  public static isAlphaNumericRequired() {
    return Validators.compose([
      Validators.required,
      Validators.pattern('[a-zA-Z0-9 ]*')
    ]);
  }

  public static isCustomNumericRequired1() {
    return Validators.compose([
      Validators.required,
      Validators.pattern('^[0-9]{0,4}(\.[0-9]{1,2})?$')
    ]);
  }



  public static isValidPasswordRequired() {

    // return Validators.compose([Validators.required,
    // Validators.pattern('^(?=\S*[a-z])(?=\S*[A-Z])(?=\S*\d)(?=\S*[^\w\s])\S{8,20}$')])

    return Validators.compose([Validators.required,
      Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^A-Za-z0-9]).{8,20}$')])
  
  }
  public static isValidEmailRequired() {
    return Validators.compose([
      Validators.required,
      //Validators.email
      Validators.pattern('^[a-zA-Z0-9._%+-]{1,64}@[a-zA-Z0-9.-]{1,255}\\.[a-zA-Z]{2,4}$')
    ]);
  }
  // public static isValidMobileRequired() {
  //   return Validators.compose([
  //     Validators.required,
  //     Validators.pattern('^((\\91-?)|0)?[0-9]{10}$')
  //   ]);
  // }
  public static isValidMobileRequired() {
    return Validators.compose([
      Validators.required,
      Validators.pattern('^((\\91-?)|0|091)?[0-9]{10}$')


    ]);
  }

  public static isTimeIntervalRequired() {
    return Validators.compose([
      Validators.required,
      Validators.pattern('^([0-9][0-9]):[0-5][0-9]$')
    ]);
  }
  public static isMatchPassword() {
    // return Validators.compose([
    //   Validators.required,
    //   Validators.pattern('^([0-9][0-9]):[0-5][0-9]$')
    // ]);
  }

  public static isDecimals() {
    return Validators.compose([
      Validators.pattern('^[0-9]+([.][0-9]+)?$'),
    ]);
  }

  public static customDriverConductorValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    
    let userType;
    let selectedCounts;
    if(control.parent?.get('intUserTypeID')?.value != null){
      userType = control.parent?.get('intUserTypeID')?.value;
    }
    if(control.value != null){
      selectedCounts = control.value;
      if ((userType == 2 || userType == 3) && selectedCounts.length > 1) {
        return { 'invalidCount': true };
      }
    }   

    return null;
  };  

  public static licenceExpiryValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    
    let userType;
    if(control.parent?.get('intUserTypeID')?.value != null){
      userType = control.parent?.get('intUserTypeID')?.value;
    }    

    if ((userType == 2)) {
      const value = control.value;
        if (!value) {
          return { 'licenceExpiryRequired': true };
        }
    }
    return null;
  };
  public static atLeastOneValueRequired: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
    const selectedValues = control.value;  // Multi-select's value
    
    // If no values are selected, return the validation error
    if (!selectedValues || selectedValues.length === 0) {
      return { 'atLeastOneValueRequired': true };
    }

    // If at least one value is selected, return null (valid)
    return null;
  };  

}
